"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var Globe = function (_a) {
    var fill = _a.fill, props = __rest(_a, ["fill"]);
    return (React.createElement("svg", __assign({ fill: "none", viewBox: "0 0 24 24", width: "1em", height: "1em" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm3.116 2.63c.595.926 1.085 2.055 1.416 3.37h2.398a8.03 8.03 0 0 0-3.814-3.37zM14.46 8c-.58-1.935-1.544-3.192-2.46-3.836-.916.644-1.88 1.901-2.46 3.836h4.92zm-5.339 2h5.756c.079.618.122 1.285.122 2 0 .715-.043 1.382-.122 2H9.122A15.83 15.83 0 0 1 9 12c0-.715.043-1.382.122-2zM7.468 8c.331-1.315.821-2.444 1.416-3.37A8.031 8.031 0 0 0 5.07 8h2.398zm-.359 2C7.038 10.635 7 11.302 7 12s.038 1.365.11 2H4.251A8.015 8.015 0 0 1 4 12c0-.69.088-1.36.252-2h2.857zm.359 6H5.07a8.032 8.032 0 0 0 3.814 3.37C8.29 18.445 7.8 17.316 7.468 16zm7.648 3.37A8.031 8.031 0 0 0 18.93 16h-2.398c-.331 1.315-.821 2.444-1.416 3.37zM14.46 16H9.539c.58 1.935 1.545 3.192 2.461 3.837.916-.645 1.88-1.902 2.46-3.837zm2.43-2h2.857a8 8 0 0 0 .252-2 8 8 0 0 0-.252-2H16.89c.071.635.109 1.302.109 2s-.038 1.365-.11 2z", fill: fill || 'currentColor' })));
};
exports.default = Globe;
